class DataTable {
  constructor(options, filter = "") {
    this.options = options;
    this.filter = filter;
  }

  static getDefaultOptions(sortBy = "id", sortDesc = false) {
    return {
      itemsPerPage: 10,
      sortBy: [sortBy],
      page: 1,
      sortDesc: [sortDesc]
    };
  }

  get params() {
    const { sortBy, sortDesc, page, itemsPerPage } = this.options;

    return {
      page,
      perPage: itemsPerPage,
      orderBy: sortBy[0] ? sortBy[0] : "",
      sortDesc: sortDesc[0] ? sortDesc[0] : "false",
      filter: this.filter
    };
  }

  async fill(response, instance) {
    instance.items = response.data;
    instance.totalItems = response.meta ? response.meta.total : response.total;

    return instance;
  }
}

export default DataTable;
